import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getUser } from 'lib/msal';
import { appInsights } from 'lib/appInsights';
import { Link } from 'react-router-dom';
import { getRootUrl } from 'helpers/url';
import { Button, Block, translate } from '@haldor/ui';

var RequiredDataError = /*#__PURE__*/function (_Component) {
  _inherits(RequiredDataError, _Component);

  var _super = _createSuper(RequiredDataError);

  function RequiredDataError() {
    var _this;

    _classCallCheck(this, RequiredDataError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props$error;

      var user = getUser();
      appInsights.trackTrace({
        message: "EDU013 - API error"
      }, {
        error: (_this$props$error = _this.props.error) === null || _this$props$error === void 0 ? void 0 : _this$props$error.data
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInformation", function () {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, _this.props.translate('something-went-wrong')), /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: '1.65rem'
        }
      }, _this.props.translate('Internal Message'), ": ", _this.props.translate(_this.props.errorMessage)), /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: '1.65rem'
        }
      }, _this.props.translate('It seems like something went wrong while we were trying to load data. Try reloading.') + ' ', _this.props.translate('If this does not work, contact your teacher, administrator or Haldor. Haldor can be reached via our Support.')), /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: '1rem'
        }
      }, _this.props.translate('Please leave this session ID in the support ticket: '), " ", /*#__PURE__*/React.createElement("strong", null, localStorage.getItem('hsid'))), /*#__PURE__*/React.createElement("a", {
        href: "https://haldor.zendesk.com/hc/sv/requests/new",
        target: "_blank",
        style: {
          display: 'inline-block',
          marginTop: '1rem'
        }
      }, _this.props.translate('Submit support ticket')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.65rem'
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: getRootUrl()
      }, /*#__PURE__*/React.createElement(Button, null, _this.props.translate('Reload page'))), /*#__PURE__*/React.createElement(Link, {
        to: "/logout",
        style: {
          marginLeft: '.65rem'
        }
      }, _this.props.translate('log-out'))));
    });

    return _this;
  }

  _createClass(RequiredDataError, [{
    key: "render",
    value: function render() {
      if (window.location.pathname == '/tab-configure' || window.location.pathname == '/course-plan-configure') {
        return this.renderInformation();
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          maxWidth: 650,
          margin: '0 auto',
          marginTop: '3rem'
        }
      }, /*#__PURE__*/React.createElement(Block, null, this.renderInformation())));
    }
  }]);

  return RequiredDataError;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(RequiredDataError);